import { getLanguage } from '../constants/languages'

const TRANSLATION_LOCATION = 'components.career.assessment_language_hint.'

/**
 * Beschreibung unter "Sprache des Assessments", als description des
 * SelectMenu wie bei "Externe Stellen-ID". Im Normalfall sagt sie nur, was
 * die Auswahl steuert. Weicht die Auswahl in den Einstellungen einer
 * bestehenden Stelle von der gespeicherten ab, nennt sie an derselben Stelle
 * die eine Folge, die nicht offensichtlich ist.
 */
export const getAssessmentLanguageDescription = ({
  t,
  language,
  savedLanguage,
  hasCustomMailTemplate = false
}) => {
  const isChanged = !!savedLanguage && !!language && language !== savedLanguage
  if (!isChanged) return t(TRANSLATION_LOCATION + 'description')

  // Mit eigenen Vorlagen ist der Hinweis auf die Vorlagen wichtiger als die
  // bisherige Sprache, "nur für neue Einladungen" sagt das Übrige schon
  if (hasCustomMailTemplate) {
    return t(TRANSLATION_LOCATION + 'change_note_custom_templates')
  }

  return t(TRANSLATION_LOCATION + 'change_note', {
    language: t(getLanguage(savedLanguage))
  })
}
